import React from 'react';
import Hero from './Components/Hero';
import Navbar from './Components/Navbar';
import Projects from './Components/Projects';
import Technologies from './Components/Technologies';
import WorkPlaces from './Components/WorkPlaces';
import About from './Components/About';
import Creative from './Components/Creative';
import Footer from './Components/Footer';

const App: React.FC = () => {
    return (
        <div>
            <Navbar />
            <Hero />
            <Projects />
            <Technologies />
            <WorkPlaces />
            <About />
            <Creative />
            <Footer />
        </div>
    );
};

export default App;
